import { render, staticRenderFns } from "./account.pc.vue?vue&type=template&id=85db1000&scoped=true&"
import script from "./account.pc.vue?vue&type=script&lang=js&"
export * from "./account.pc.vue?vue&type=script&lang=js&"
import style0 from "./account.pc.vue?vue&type=style&index=0&id=85db1000&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85db1000",
  null
  
)

export default component.exports